// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

/**
* Generated from evaka.core.setting.SettingType
*/
export const settings = [
  'DECISION_MAKER_NAME',
  'DECISION_MAKER_TITLE'
] as const

export type SettingType = typeof settings[number]
